export default __webpack_public_path__ + "static/media/Ganeshchaturti5.12ef7bb8.JPG";